import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=18a2e74e&scoped=true&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"
import style0 from "./Notifications.scss?vue&type=style&index=0&id=18a2e74e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a2e74e",
  null
  
)

export default component.exports